import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const PreviewPage = () => {
  const { id } = useParams();
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Utility function to get cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  useEffect(() => {
    const fetchPreviewData = async () => {
      const token = getCookie("token");
      const userid = getCookie("userid");

      if (!token || !userid) {
        setError("Missing authentication credentials");
        setLoading(false);
        return;
      }

      try {
        const requestBody = {
          htmldocid: id,
        };

        const response = await axios.post(
          'https://api.dqr-display-tms.eventum.co.in/api/HtmlDocInfoOperation/Search',
          requestBody,
          {
            headers: {
              "X-Authorization": token,
              UserId: userid,
              "Content-Type": "application/json-patch+json",
            },
          }
        );

        if (response.data && Array.isArray(response.data.data)) {
          // Sort by position and combine HTML content
          const sortedData = response.data.data.sort((a, b) => a.position - b.position);
          const combinedHtml = sortedData.map(item => item.htmlcontent || "").join("\n");
          setHtmlContent(combinedHtml);
        } else {
          setHtmlContent("");
        }
      } catch (err) {
        console.error("Error fetching preview data:", err);
        setError("Failed to load preview");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPreviewData();
    }
  }, [id]);

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>Loading preview...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p style={{ color: "red" }}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <iframe
        title="HTML Preview"
        srcDoc={htmlContent}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
};

export default PreviewPage;

